import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {AudioSource} from '@wonderlandengine/spatial-audio';
import {RewardScreenUi} from './rewardScreenUi.js';

/**
 * reward-screen
 */
export class RewardScreen extends Component {
    static TypeName = 'reward-screen';

    @property.object({required: true})
    rewardUi!: Object3D;

    levelText!: string;
    xpGainedText!: string;
    audioLevelUp!: AudioSource;

    objects: Object3D[] = [];

    currentPercent: number = 0.0;
    targetPercent: number = 1.0;
    duration: number = 1.0;
    value: number = 0;

    public async gainXP(gain: number) {
        this.rewardUi.getComponent(RewardScreenUi)?.gainXP(gain);
    }
}
